import { Loader } from "components/loader";
import { CognitiveSearchView, CognitiveSearchView1 } from "dsilo-ui-components";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { PUBLIC_PATH } from "../../constants";
import {
  clearReduxDataOfCurrentComponent,
  downloadContractPDFAction,
  getCognitiveSearchV1Data,
  getModelDataDropDown,
  deleteSavedSearchDataById,
  getModelData,
  downloadSheet,
  saveAdvancedSearchData,
  getAllSavedSearchData,
  getPDFForAllOtherDoc
} from '../../store/actions';
import adobeLogo from '../../images/adobe-pdf-icon.png';

const CognitiveSearchComponent = props => {
  return (
    <div>
      {props?.isNewV1Theme
        ? <CognitiveSearchView1
          adobeLogo={adobeLogo}
          loader={<Loader />}
          PUBLIC_PATH={PUBLIC_PATH}
          {...props}
        />
        : <CognitiveSearchView
          adobeLogo={adobeLogo}
          loader={<Loader />}
          PUBLIC_PATH={PUBLIC_PATH}
          {...props}
        />
      }
    </div>
  );
};

const mapDispatchToProps = {
  clearReduxDataOfCurrentComponent,
  downloadContractPDFAction,
  getCognitiveSearchV1Data,
  getModelDataDropDown,
  deleteSavedSearchDataById,
  getModelData,
  saveAdvancedSearchData,
  getAllSavedSearchData,
  downloadSheet,
  getPDFForAllOtherDoc
};

const mapStateToProps = state => {
  return {
    appConfig: state.appConfig.app,
    apps: state.app.app,
    login: state.login,
    user: state.user,
    formData: state.form,
    contractAnnotations: state.contractAnnotations,
    model: state.model,
    members: state.appConfig.members,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CognitiveSearchComponent));
